import { Typography } from '@mui/material';
import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

type Props = {
  letter: string;
  pageNumber: number;
};

const LetterDot: React.FC<Props> = ({ letter, pageNumber }) => {
  const classes = useStyles();
  const isLeftPage = pageNumber % 2 === 0;

  return (
    <div className={`${classes.root} ${isLeftPage ? 'left' : 'right'}`}>
      <Typography variant="h1" className={classes.typography}>
        {letter.toUpperCase()}
        {letter.toLowerCase()}
      </Typography>
    </div>
  );
};

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    position: 'absolute',
    height: '10vh',
    width: '10vh',
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[3],
    borderRadius: '50%',
    top: theme.spacing(4),
    zIndex: theme.zIndex.appBar,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '&.left': {
      left: theme.spacing(3),
    },
    '&.right': {
      right: theme.spacing(3),
    },
  },
  typography: {
    paddingTop: theme.spacing(2),
  },
}));

export default LetterDot;
